module.exports = __webpack_public_path__ + "sos.jpg?040bb8f034aceda6129cc1f06fe1161b";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/projetos/sos.jpg
// module id = 155
// module chunks = 0